const contactItems = [
  {
    icon: "ri-map-pin-2-line",
    label: "公司地址",
    value: "厦门市集美区软件园三期B区02栋1203室",
  },
  {
    icon: "ri-user-line",
    label: "联系人",
    value: "葛肇锋",
  },
  {
    icon: "ri-phone-line",
    label: "联系电话",
    value: "13860171140",
  },
  {
    icon: "ri-mail-send-line",
    label: "电子邮箱",
    value: "williamge@xmgrt.com.cn",
  },
  {
    icon: "ri-printer-line",
    label: "传真",
    value: "0592-2918131",
  },
  {
    icon: "ri-time-line",
    label: "服务时间",
    value: "周一至周六 08:30 – 18:00",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="py-28 bg-[#F4F8FF]">
      <div className="max-w-6xl mx-auto px-6">

        {/* Section header */}
        <div className="flex flex-col items-center text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#0EA5E9]/10 mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#0EA5E9]" />
            <span className="text-[#0EA5E9] text-xs font-semibold tracking-widest uppercase">Contact Us</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0D1F3C] mb-5 leading-tight">
            联系格睿特
            <br />
            <span className="text-[#0EA5E9]">开启合作之旅</span>
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-xl leading-relaxed">
            专业团队随时为您提供产品询价、技术选型及售后支持，
            欢迎随时与我们取得联系。
          </p>
        </div>

        {/* Divider */}
        <div className="w-16 h-px bg-[#0EA5E9]/30 mx-auto mb-20" />

        {/* Contact grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {contactItems.map((item) => (
            <div
              key={item.label}
              className="group flex flex-col items-center text-center px-8 py-10 rounded-2xl bg-white border border-gray-100 transition-all duration-300 hover:-translate-y-1 hover:border-[#0EA5E9]/30 hover:shadow-[0_4px_24px_rgba(14,165,233,0.08)] cursor-default"
            >
              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-[#0EA5E9]/8 group-hover:bg-[#0EA5E9]/15 transition-colors duration-300 mb-5">
                <i className={`${item.icon} text-[#0EA5E9] text-2xl`} />
              </div>

              {/* Label */}
              <p className="text-[11px] font-semibold text-gray-400 tracking-widest uppercase mb-2">
                {item.label}
              </p>

              {/* Value */}
              <p className="text-[#0D1F3C] font-semibold text-base leading-snug break-all">
                {item.value}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom tagline */}
        <div className="mt-20 flex flex-col items-center gap-3 text-center">
          <div className="w-8 h-px bg-[#0EA5E9]/40" />
          <p className="text-gray-400 text-sm tracking-wide">
            格睿特电子 · 厦门市集美区 · 全国配送 · 专业服务
          </p>
        </div>

      </div>
    </section>
  );
}
